import { createTheme } from "@mantine/core"

export const theme = createTheme({
  fontFamily: "Poppins",
  // primaryColor: "red",
  // ... other theme override properties
})
